<template>
  <div class="cashcoupon">
    <header>
      <ul>
        <li
          :class="{ navColor: tagIndex == index }"
          v-for="(item, index) in navList"
          :key="index"
          @click="navClick(index)"
        >
          {{ item }}
          <span v-if="tagIndex == index"></span>
        </li>
      </ul>
    </header>
    <div class="couponBigbox">
      <div class="coupon_list" v-if="wlist && wlist.length > 0">
        <ul>
          <li v-for="(item, index) of wlist" :key="index">
            <div class="couponContent" :class="{ couponContent2: tagIndex == 1 }">
              <img
                v-if="tagIndex == 0 && item.isspecial == 0"
                src="../../assets/images/coupon4.png"
              />
              <img
                v-if="tagIndex == 0 && item.isspecial == 1"
                src="../../assets/images/coupon4-1.png"
              />
              <div v-if="tagIndex == 1" class="couponbox"></div>
              <div
                class="couponBottom"
                v-if="item.isShow"
                :class="[
                  { coupon: item.isShow && navIndex == 0 && item.isuse === '1' },
                  { coupon2: item.isShow && item.isuse === '0' }
                ]"
              >
                <p>{{ item.content }}</p>
              </div>
              <div class="couponCon">
                <div style="overflow: hidden">
                  <div
                    class="couponLeft couponLeftOne"
                    :class="{ couponLeft11: item.isspecial == 1 }"
                  >
                    <img v-if="tagIndex == 1" v-lazy="item.path" />
                    <div v-if="tagIndex == 0" class="goods_price">
                      <span class="smallprice" v-if="item.isdiscountcoupon != 1">
                        <sub v-if="item.coupontype == 1 || item.coupontype == 2">¥</sub>
                        <b>{{ item.money }}</b>
                        <sup v-if="item.coupontype == 4">折</sup>
                      </span>
                      <span class="smallprice" v-else>
                        <b>-{{ item.money }}</b>
                      </span>
                    </div>
                    <p v-if="tagIndex == 0">{{ item.name }}</p>
                  </div>
                  <div class="couponRight">
                    <p class="over-ell-1" v-if="tagIndex == 0">{{ item.gettype }}</p>
                    <p class="over-ell-1" v-if="tagIndex == 1">{{ item.name }}</p>
                    <b v-if="item.timeType == 1">
                      <van-count-down
                        class="f10 lh17"
                        :time="item.countDown"
                        @finish="countDownFinish(item, index)"
                      >
                        <template #default="timeData">
                          {{
                            (item.couponNum > 1 ? '有一张优惠券还有' : '当前优惠券还有') +
                            ((timeData.days > 0 ? timeData.days + '天' : '') +
                              (timeData.hours > 0 || timeData.days > 0
                                ? (timeData.hours >= 0 && timeData.hours < 10
                                    ? '0' + timeData.hours
                                    : timeData.hours) + '时'
                                : '') +
                              (timeData.minutes >= 0 && timeData.minutes < 10
                                ? '0' + timeData.minutes
                                : timeData.minutes) +
                              '分' +
                              (timeData.seconds >= 0 && timeData.seconds < 10
                                ? '0' + timeData.seconds
                                : timeData.seconds) +
                              '秒') +
                            '过期'
                          }}
                        </template>
                      </van-count-down>
                    </b>
                    <b v-else>
                      {{ item.begin_time.replace(/-/g, '.') }}-{{
                        item.end_time.replace(/-/g, '.')
                      }}
                    </b>
                    <div :class="tagIndex == 1 ? 'couponfooter_pro' : ''" class="couponfooter">
                      <span v-if="item.content != ''">
                        详细信息
                        <van-icon
                          @click.stop="couponDetailClick(item, index)"
                          v-if="!item.isShow"
                          name="arrow-down"
                          color="#B7B7B7"
                        />
                        <van-icon
                          @click.stop="couponDetailClick(item, index)"
                          v-if="item.isShow"
                          name="arrow-up"
                          color="#B7B7B7"
                        />
                      </span>
                      <div class="btnBox">
                        <button
                          v-if="item.present == 1 || item.isshare == 1"
                          class="btn redBtn redBorBtn"
                          @click.stop="goShare(item)"
                        >
                          去赠送
                        </button>
                        <button
                          @click="couponFn(item)"
                          class="btn redBtn"
                          v-if="item.beginTime <= item.serverTime && item.isdiscountcoupon != 1"
                        >
                          去使用
                        </button>
                        <button
                          class="btn orangeBtn"
                          v-if="item.beginTime > item.serverTime && item.isdiscountcoupon != 1"
                        >
                          待使用
                        </button>
                        <button
                          @click="couponFn(item)"
                          class="btn redBtn"
                          v-if="item.isdiscountcoupon == 1"
                        >
                          去逛逛
                        </button>
                      </div>
                    </div>
                    <div class="tags">
                      <img v-if="item.navIndex == 1" src="../../assets/images/yishiyong.png" />
                      <img v-if="item.navIndex == 2" src="../../assets/images/yishixiao.png" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="coupon_list" v-if="ylist && ylist.length > 0">
        <div class="title">
          <p>已使用</p>
          <button @click="deleteClick(2)">清空</button>
        </div>
        <ul>
          <li v-for="(item, index) of ylist" :key="index">
            <div class="couponContent" :class="{ couponContent2: tagIndex == 1 }">
              <img
                v-if="tagIndex == 0 && item.isspecial == 0"
                src="../../assets/images/coupon5.png"
              />
              <img
                v-if="tagIndex == 0 && item.isspecial == 1"
                src="../../assets/images/coupon-grey-4-1.png"
              />
              <div class="couponbox" v-if="tagIndex == 1"></div>
              <div
                class="couponBottom"
                v-if="item.isShow"
                :class="[
                  { coupon: item.isShow && navIndex == 0 && item.isuse === '1' },
                  { coupon2: item.isShow && item.isuse === '0' }
                ]"
              >
                <p>{{ item.content }}</p>
              </div>
              <div class="couponCon">
                <div style="overflow: hidden">
                  <div class="couponLeft couponLeftTwo">
                    <img v-if="tagIndex == 1" v-lazy="item.path" />
                    <div v-if="tagIndex == 0" class="goods_price">
                      <span class="smallprice" v-if="item.isdiscountcoupon != 1">
                        <sub v-if="item.coupontype == 1 || item.coupontype == 2">¥</sub>
                        <b>{{ item.money }}</b>
                        <sup v-if="item.coupontype == 4">折</sup>
                      </span>
                      <span class="smallprice" v-else>
                        <b>-{{ item.money }}</b>
                      </span>
                    </div>
                    <p v-if="tagIndex == 0">{{ item.name }}</p>
                  </div>
                  <div class="couponRight couponRightGray">
                    <p class="over-ell-1" v-if="tagIndex == 0">{{ item.gettype }}</p>
                    <p class="over-ell-1" v-if="tagIndex == 1">{{ item.name }}</p>
                    <b>
                      {{
                        item.timeType == 1
                          ? '当前优惠券已使用'
                          : item.begin_time.replace(/-/g, '.')
                      }}-{{ item.end_time.replace(/-/g, '.') }}
                    </b>
                    <div :class="tagIndex == 1 ? 'couponfooter_pro' : ''" class="couponfooter">
                      <span v-if="item.content != ''">
                        详细信息
                        <van-icon
                          @click.stop="couponDetailClick(item, index)"
                          v-if="!item.isShow"
                          name="arrow-down"
                          color="#A0A0A0"
                        />
                        <van-icon
                          @click.stop="couponDetailClick(item, index)"
                          v-if="item.isShow"
                          name="arrow-up"
                          color="#A0A0A0"
                        />
                      </span>
                      <div class="btnBox">
                        <button
                          v-if="item.ifsend == 1"
                          class="btn redBtn"
                          style="
                            background: transparent;
                            border: 0.01rem solid #d8d8d8;
                            color: #d8d8d8;
                          "
                        >
                          已赠送
                        </button>
                        <button v-else class="btn redBtn" style="background: #d8d8d8">
                          已使用
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="coupon_list" v-if="ylist1 && ylist1.length > 0">
        <div class="title">
          <p>已失效</p>
          <button @click="deleteClick(3)">清空</button>
        </div>
        <ul>
          <li v-for="(item, index) of ylist1" :key="index">
            <div class="couponContent" :class="{ couponContent2: tagIndex == 1 }">
              <img v-if="tagIndex == 0" src="../../assets/images/coupon5.png" />
              <div v-if="tagIndex == 1" class="couponbox"></div>
              <div
                class="couponBottom"
                v-if="item.isShow"
                :class="[
                  { coupon: item.isShow && navIndex == 0 && item.isuse === '1' },
                  { coupon2: item.isShow && item.isuse === '0' }
                ]"
              >
                <p>{{ item.content }}</p>
              </div>
              <div class="couponCon">
                <div style="overflow: hidden">
                  <div class="couponLeft couponLeftThree">
                    <img v-if="tagIndex == 1" v-lazy="item.path" />
                    <div v-if="tagIndex == 0" class="goods_price">
                      <span class="smallprice" v-if="item.isdiscountcoupon != 1">
                        <sub v-if="item.coupontype == 1 || item.coupontype == 2">¥</sub>
                        <b>{{ item.money }}</b>
                        <sup v-if="item.coupontype == 4">折</sup>
                      </span>
                      <span class="smallprice" v-else>
                        <b>-{{ item.money }}</b>
                      </span>
                    </div>
                    <p v-if="tagIndex == 0">{{ item.name }}</p>
                  </div>
                  <div class="couponRight couponRightGray">
                    <p class="over-ell-1" v-if="tagIndex == 0">{{ item.gettype }}</p>
                    <p class="over-ell-1" v-if="tagIndex == 1">{{ item.name }}</p>
                    <b>
                      {{
                        item.timeType == 1
                          ? '当前优惠券已过期'
                          : item.begin_time.replace(/-/g, '.') +
                            '-' +
                            item.end_time.replace(/-/g, '.')
                      }}
                    </b>
                    <div :class="tagIndex == 1 ? 'couponfooter_pro' : ''" class="couponfooter">
                      <span v-if="item.content != ''">
                        详细信息
                        <van-icon
                          @click.stop="couponDetailClick(item, index)"
                          v-if="!item.isShow"
                          name="arrow-down"
                          color="#A0A0A0"
                        />
                        <van-icon
                          @click.stop="couponDetailClick(item, index)"
                          v-if="item.isShow"
                          name="arrow-up"
                          color="#A0A0A0"
                        />
                      </span>
                      <div class="btnBox">
                        <button class="btn redBtn" style="background: #dddddd">去使用</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div ref="noCoupon" style="display: none; padding-top: 0.45rem">
      <empty :path="'noCoupon'" :type="tagIndex"></empty>
    </div>
    <van-overlay :show="showshare" z-index="99"></van-overlay>
    <div class="sharecontainer sharetitle" v-if="showshare === true">
      <img src="/static/images/sharemc.png" />
      <van-button round plain type="danger" class="know" @click="showshare = false">
        我知道了
      </van-button>
    </div>
  </div>
</template>

<script>
import empty from '../emptypage/empty'
import { Base64, fenxiang, isWeixin, bannerClick } from '../../assets/common/js/config'

export default {
  name: 'cashCoupon',
  components: {
    empty
  },
  data() {
    return {
      navList: ['现金劵', '产品劵'],
      tagIndex: this.$route.query.navIndex ? this.$route.query.navIndex : 0,
      navIndex: 0,
      wlist: [],
      ylist: [],
      ylist1: [],
      title: '',
      desc: '',
      img: '',
      discountsharetitle: '',
      discountsharedesc: '',
      discountshareimg: '',
      sharetitle: '',
      sharedesc: '',
      shareimg: '',
      listIndex: null,
      istagclick: 1,
      showshare: false
    }
  },
  mounted: function () {
    if (isWeixin()) {
      fenxiang({ path: 'cashcoupon' })
    }
    this.getData()
    this.days()
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  methods: {
    getDateTime(oneDateStr) {
      var newTime = oneDateStr.replace(/\./g, '-')
      return newTime
    },
    countDownFinish(item, index) {
      if (item.couponNum == 1) {
        item.isuse = 2
        item.isShow = false
        item.navIndex = this.navIndex = 2
        this.wlist.splice(index, 1)
        this.ylist1.unshift(item)
      } else {
        this.getData()
      }
    },
    getData: function () {
      var url
      if (this.tagIndex == 0) {
        url = this.$ajax.getCoupons_URL
      } else {
        url = this.$ajax.getProdCoupons_URL
      }
      var that = this
      that.$customRequestAjax(url).then((res) => {
        if (res.data.code == 200) {
          if (that.tagIndex == 0) {
            that.title = res.data.sharetitle
            that.desc = res.data.sharedesc
            that.img = res.data.shareimg
            that.sharetitle = res.data.sharetitle
            that.sharedesc = res.data.sharedesc
            that.shareimg = res.data.shareimg
            that.discountsharetitle = res.data.discountsharetitle
            that.discountsharedesc = res.data.discountsharedesc
            that.discountshareimg = res.data.discountshareimg
          }
          for (var i = 0; i < res.data.list.length; i++) {
            res.data.list[i].beginTime = new Date(
              that.getDateTime(res.data.list[i].begin_time).replace(/-/g, '/')
            ).getTime()
            res.data.list[i].serverTime = new Date(
              that.getDateTime(res.data.list[i].server_time).replace(/-/g, '/')
            ).getTime()
            res.data.list[i].endTime = new Date(
              that.getDateTime(res.data.list[i].end_time).replace(/-/g, '/')
            ).getTime()
            res.data.list[i].countDown = res.data.list[i].endTime - res.data.list[i].serverTime
            if (res.data.list[i].isuse == 0) {
              res.data.list[i].isShow = false
              res.data.list[i].navIndex = that.navIndex = 0
              that.wlist.push(res.data.list[i])
            } else if (res.data.list[i].isuse == 1) {
              res.data.list[i].isShow = false
              res.data.list[i].navIndex = that.navIndex = 1
              that.ylist.push(res.data.list[i])
            } else if (res.data.list[i].isuse == 2) {
              res.data.list[i].isShow = false
              res.data.list[i].navIndex = that.navIndex = 2
              that.ylist1.push(res.data.list[i])
            }
          }
          if (that.wlist.length + that.ylist.length + that.ylist1.length <= 0) {
            that.$refs.noCoupon.style.display = 'block'
          } else {
            that.$refs.noCoupon.style.display = 'none'
          }
          that.istagclick = that.tagIndex
        }
      })
    },
    days(time, curtime) {
      var date = new Date(curtime).getTime()
      var date1 = new Date(time).getTime()
      var days = (date1 - date) / 1000 / 60 / 60 / 24
      var hours = (date1 - date) / 1000 / 60 / 60
      if (days >= 1) {
        days = parseInt(days)
        return days + '天后生效'
      } else if (days < 1 && days > 0 && hours >= 1) {
        hours = parseInt(hours)
        return hours + '小时后生效'
      } else if (hours < 1 && hours > 0) {
        hours = 1
        return hours + '小时内生效'
      }
    },
    navClick: function (id) {
      if (this.tagIndex != id) {
        if (this.istagclick != null && this.istagclick == id) {
          return
        }
        this.tagIndex = id
        this.navIndex = 0
        this.wlist = []
        this.ylist = []
        this.ylist1 = []
        this.$refs.noCoupon.style.display = 'none'
        this.getData()
      }
    },
    deleteClick: function (type) {
      var url, msg
      var that = this
      if (this.tagIndex == 0) {
        url = this.$ajax.deleteCoupons_URL + '?type=' + type + '&coupontype=' + (this.tagIndex + 1)
        msg = type == 2 ? '删除已使用现金劵？' : type == 3 ? '删除已失效现金劵' : ''
      } else {
        url = this.$ajax.deleteCoupons_URL + '?type=' + type + '&coupontype=' + (this.tagIndex + 1)
        msg = type == 2 ? '删除已使用产品劵？' : type == 3 ? '删除已失效产品劵' : ''
      }
      this.$dialog
        .confirm({
          message: msg,
          className: 'collect_button_alert cash-coupon',
          cancelButtonColor: '#FC0324',
          confirmButtonColor: '#FFFCFC',
          confirmButtonText: '删除'
        })
        .then(function () {
          // on confirm
          that.$customRequestAjax(url).then((res) => {
            if (res.data.code === 200) {
              if (type == 2) {
                that.ylist = []
                if (!that.wlist.length && !that.ylist.length && !that.ylist1.length) {
                  that.$refs.noCoupon.style.display = 'block'
                } else {
                  that.$refs.noCoupon.style.display = 'none'
                }
              } else if (type == 3) {
                that.ylist1 = []
                if (!that.wlist.length && !that.ylist.length && !that.ylist1.length) {
                  that.$refs.noCoupon.style.display = 'block'
                } else {
                  that.$refs.noCoupon.style.display = 'none'
                }
              }
            }
          })
        })
        .catch(function () {
          // on cancel
        })
    },
    couponDetailClick: function (items, id) {
      this.listIndex = id
      items.isShow = !items.isShow
    },
    goShare(items) {
      this.showshare = true
      var that = this,
        base = new Base64(),
        coupon_type = items.isdiscountcoupon == 1 ? 2 : 0
      if (this.tagIndex != 0) {
        coupon_type = 5
      }
      if (coupon_type == 0) {
        that.title = that.sharetitle
        that.desc = that.sharedesc
        that.img = that.shareimg
      } else if (coupon_type != 5) {
        that.title = that.discountsharetitle
        that.desc = that.discountsharedesc
        that.img = that.discountshareimg
      } else {
        that.title = items.shareTitle
        that.desc = items.shareDesc
        that.img = items.shareImg
      }
      fenxiang({
        title: encodeURIComponent(that.title),
        desc: encodeURIComponent(that.desc),
        imgx: that.img,
        type: 'trancoupon',
        dataStr:
          'type=trancoupon&params=' +
          base.encode(JSON.stringify({ mecouponid: items.id, coupon_type: coupon_type })),
        path: 'cashcoupon'
      })
    },
    couponFn(items) {
      if (items.ismeetingcoupon == 1) {
        this.$customRequestAjax(this.$ajax.checkNowOfflineMeetingStatus_URL).then((res) => {
          if (res.data.code == 200) {
            window.location.href = res.data.url
          }
        })
      } else if (items.isdiscountcoupon == 1) {
        window.location.href = items.url
      } else {
        if (items.navIndex == 0 && items.isuse == '0') {
          if (items.jumppage) {
            window.location = items.jumppage
          } else if (items.linkObj && Object.keys(items.linkObj).length > 0) {
            bannerClick(items.linkObj, items.id, 'couponList', this, null, 'couponList', {
              point: { buttontext: items.id }
            })
          } else {
            this.$router.push({
              path: '/'
            })
          }
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.cashcoupon {
  /*background: #fff;*/
  header {
    background: #fff;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    z-index: 1;
    ul {
      background: #fff;
      display: flex;
      display: -o-flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -webkit-flex;
      li {
        width: 50%;
        padding: 0.12rem 0;
        text-align: center;
        font-size: 0.15rem;
        font-weight: 400;
        color: #4b4b4b;
        line-height: 0.21rem;
        position: relative;
        &.navColor {
          color: #fe0f41;
          font-weight: 600;
        }
        span {
          position: absolute;
          left: 50%;
          bottom: 0.08rem;
          transform: translateX(-50%);
          -o-transform: translateX(-50%);
          -moz-transform: translateX(-50%);
          -ms-transform: translateX(-50%);
          -webkit-transform: translateX(-50%);
          display: block;
          width: 0.24rem;
          height: 0.025rem;
          background: linear-gradient(90deg, #fc0324, #ff5168);
          background: -webkit-gradient(linear, left top, right top, from(#fc0324), to(#ff5168));
          background: -moz-linear-gradient(90deg, #fc0324, #ff5168);
          background: -ms-linear-gradient(90deg, #fc0324, #ff5168);
          background: -o-linear-gradient(90deg, #fc0324, #ff5168);
        }
      }
    }
  }
  .couponBigbox {
    padding-top: 0.45rem;
  }
  .sharecontainer {
    position: fixed;
    width: 100%;
    z-index: 100;
    height: 100%;
    left: 0;
    top: 0;
  }
  .sharecontainer img {
    position: absolute;
    top: 0.2rem;
    right: 0.73rem;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: 50%;
  }
  .sharecontainer .know {
    width: 1.09rem;
    height: 0.36rem;
    line-height: 0.36rem;
    color: #fff;
    border-color: #fff;
    background: transparent;
    position: absolute;
    bottom: 1.5rem;
    left: 50%;
    margin-left: -0.54rem;
  }
}
</style>
<style lang="scss">
.cash-coupon {
  border-radius: 0.04rem;
  .van-dialog__content {
    .van-dialog__message {
      color: #444444;
      font-size: 0.17rem;
      overflow: initial;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/cashCoupon.vue